import {
  OAuthProvider,
  browserLocalPersistence,
  browserPopupRedirectResolver,
  connectAuthEmulator,
  initializeAuth,
  signInWithPopup,
} from 'firebase/auth';
import { idToken as _idToken, user as _user } from 'rxfire/auth';
import { Observable, throwError } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';
import { app } from './config';

const auth = initializeAuth(app, {
  persistence: browserLocalPersistence,
  popupRedirectResolver: browserPopupRedirectResolver,
});
const provider = new OAuthProvider('microsoft.com');
provider.setCustomParameters({
  tenant: 'nrk.onmicrosoft.com',
});

export const idToken = _idToken(auth);
export const withIdToken = <T>(fn: (token: string) => Observable<T>) =>
  idToken.pipe(
    take(1),
    switchMap((token) => {
      if (token == null) {
        return throwError(() => new Error('Missing token'));
      }
      return fn(token);
    })
  );

// eslint-disable-next-line turbo/no-undeclared-env-vars
if (import.meta.env.DEV) {
  connectAuthEmulator(auth, 'http://localhost:3472', { disableWarnings: true });
}

export function loginWithMicrosoft() {
  return signInWithPopup(auth, provider);
}
export function logout() {
  return auth.signOut();
}

export const user = _user(auth);
